import HTTP from "@/_helpers/http";
import { ASSIGNACCTYPE__API } from "@/_helpers/urls";
import { ASSIGNACCTYPE__MUTATIONS } from "../mutation-types";
import { ASSIGNACCTYPE__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
    allMasterIB: [],
    allAccountTypes: [],
    allMasterIBDataTable: [],
    allAccountTypesDataTable: [],
    countries: [],
    isLoading: false,
    pagination: {
        total: 0,
        perPage: 10,
        currentPage: 1,
        lastPage: 1
    },
    masterIbPagination: {
        total: 0,
        perPage: 10,
        currentPage: 1,
        lastPage: 1
    },
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [ASSIGNACCTYPE__MUTATIONS.ALLMASTERIB](state, data) {
        state.allMasterIB = data?.data?.masterIBs;
        state.allAccountTypes = data?.data?.accountTypes;
        state.pagination = data?.data?.pagination;
    },
    [ASSIGNACCTYPE__MUTATIONS.MASTERIBDATATABLE](state, data) {
        state.allMasterIBDataTable = data.data.allMasterIB;
        state.allAccountTypesDataTable = data.data.allAccountTypes;
        state.masterIbPagination = data.data.pagination;
    },
    [ASSIGNACCTYPE__MUTATIONS.UNIQUECOUNTRIES](state, data) {
        state.countries = data.countries
    },
    SET_LOADING(state, data) {
        state.isLoading = data;
    },
};

// Actions
const actions = {
    async [ASSIGNACCTYPE__ACTIONS.ALLMASTERIB]({ commit, state }, parameter = {}) {
        try {
            commit("SET_LOADING", true);

            const {
                account_type,
                country,
                page = 1,
                limit = 10,
                search = ""
            } = parameter;

            const queryParams = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...(account_type && { account_type }),
                ...(country && { country }),
                ...(search && { search })
            }).toString();

            const response = await HTTP().get(
                `${ASSIGNACCTYPE__API.ALLMASTERIB}${queryParams ? `?${queryParams}` : ''}`
            );


            commit(ASSIGNACCTYPE__MUTATIONS.ALLMASTERIB, response.data);
            commit("SET_LOADING", false);
        } catch (error) {
            console.log(error);
        }
    },

    async [ASSIGNACCTYPE__ACTIONS.MASTERIBDATATABLE]({ commit, state }, parameter = {}) {
        try {
            const {
                account_type,
                country,
                page = 1,
                limit = 10,
                search = ""
            } = parameter;

            const queryParams = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...(account_type && { account_type }),
                ...(country && { country }),
                ...(search && { search })
            }).toString();

            const response = await HTTP().get(
                `${ASSIGNACCTYPE__API.MASTERIBDATATABLE}${queryParams ? `?${queryParams}` : ''}`
            );

            if (response.status === 200) {
                commit(ASSIGNACCTYPE__MUTATIONS.MASTERIBDATATABLE, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },

    async [ASSIGNACCTYPE__ACTIONS.UNIQUECOUNTRIES]({ commit, state }) {
        try {
            const response = await HTTP().get(
                ASSIGNACCTYPE__API.UNIQUECOUNTRIES
            );

            if (response.status === 200) {
                commit(ASSIGNACCTYPE__MUTATIONS.UNIQUECOUNTRIES, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },

    async [ASSIGNACCTYPE__ACTIONS.ASSIGNSINGLEIB]({ commit, state, dispatch }, data) {
        try {
            const response = await HTTP().post(
                ASSIGNACCTYPE__API.ASSIGNSINGLEIB, data
            );

            if (response.status === 200) {
                dispatch(ASSIGNACCTYPE__ACTIONS.MASTERIBDATATABLE);
                dispatch(ASSIGNACCTYPE__ACTIONS.ALLMASTERIB);
                toast.success(response.data.message || 'Successfully updated')
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || 'Failed to update')
        }
    },

    async [ASSIGNACCTYPE__ACTIONS.ASSIGNACCTYPE]({ commit, state, dispatch }, data) {
        try {
            const response = await HTTP().post(
                ASSIGNACCTYPE__API.ASSIGNACCTYPE, data
            );

            if (response.status === 200) {
                dispatch(ASSIGNACCTYPE__ACTIONS.ALLMASTERIB);
                dispatch(ASSIGNACCTYPE__ACTIONS.MASTERIBDATATABLE);
                toast.success(response.data.message || 'Successfully updated')
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || 'Failed to update')
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
